var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWowIconDps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EA4545",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.699 12.937l2.356 2.358-.942.942.943.944-.942.942-1.65-1.65-1.886 1.886-.943-.943 1.886-1.886-1.65-1.65.943-.942.942.942.943-.943zM5.999 6l2.364.002 7.878 7.878.944-.942.943.943-1.65 1.65 1.885 1.885-.943.943-1.885-1.885-1.65 1.65-.943-.943.942-.944-7.883-7.883L6 6zm9.638 0L18 6.002l.002 2.349-2.702 2.701-2.358-2.357L15.637 6z",
    fill: "#E23F3F"
  })));
}
export default __webpack_public_path__ + "static/svg/wow-icon-dps.svg";
export { SvgWowIconDps as ReactComponent };